import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { BaseResponse } from "@/models/responses/base/baseResponse.response";

export interface ValidateCorrectionLinkResponse {
  isValid: boolean;
  reason?: "INVALID" | "USED" | "EXPIRED";
  employerCode?: string;
  currentRcNumber?: string;
  currentName?: string;
  currentAddress?: string;
  currentEmail?: string;
  currentContactPersonEmail?: string;
  currentContactPersonPhone?: string;
  currentContactPersonRole?: string;
  expiresAt?: string;
}

export interface RequestContactUpdateLinkDto {
  employerCode: string;
}

export interface RequestContactUpdateLinkResponse {
  email: string;
}

export interface SubmitContactUpdateDto {
  name: string;
  email: string;
  designation: string;
}

export interface SubmitContactUpdateResponse {
  contactPersonEmail: string;
}

const CorrectionLinkService = {
  validateLink: async function (
    token: string
  ): Promise<ValidateCorrectionLinkResponse> {
    const response = (await api.get(
      ENDPOINTS.CORRECTION_LINKS.VALIDATE(token)
    )) as unknown as BaseResponse<ValidateCorrectionLinkResponse>;
    return response.data;
  },

  /** Employer-initiated (OTP screen "change email"), as opposed to ADMIN_SEND. */
  requestContactUpdate: async function (
    dto: RequestContactUpdateLinkDto
  ): Promise<RequestContactUpdateLinkResponse> {
    const response = (await api.post(
      ENDPOINTS.CORRECTION_LINKS.REQUEST_CONTACT_UPDATE,
      dto
    )) as unknown as BaseResponse<RequestContactUpdateLinkResponse>;
    return response.data;
  },

  submitContactUpdate: async function (
    token: string,
    dto: SubmitContactUpdateDto
  ): Promise<SubmitContactUpdateResponse> {
    const response = (await api.post(
      ENDPOINTS.CORRECTION_LINKS.SUBMIT_CONTACT_UPDATE(token),
      dto
    )) as unknown as BaseResponse<SubmitContactUpdateResponse>;
    return response.data;
  },
};

export default CorrectionLinkService;
